import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ControlStatus } from '../../common/control-status';

@Component({
    selector: 'aa-field-msg-error',
    templateUrl: './field-msg-error.component.html',
    styleUrls: [
        './field-msg-error.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FieldMsgErrorComponent
{
    @Input() status: ControlStatus;
}
